const TerritoryCard = require("../../entities/Cards/TerritoryCard");
const Territories = require("../../Constants/Territories/Territories");
const ByName = require("./ByName");

const classOf = ByName(Territories);
// (version: of a territory the expansion changed, see Constants/CardVersions.js)
const TerritoryConverter = (territoryName, age, version) =>
{
    const Class = classOf(territoryName);
    return Class === undefined ? null : new TerritoryCard(new Class(age, version));
}

module.exports = TerritoryConverter;
